(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('UrgentIssuesUnknownController', UrgentIssuesUnknownController);

    UrgentIssuesUnknownController.$inject = ['$uibModalInstance', 'UrgentIssues', '$stateParams', 'CoreService',
        '$scope', 'chart'];

    function UrgentIssuesUnknownController($uibModalInstance, UrgentIssues, $stateParams, CoreService,
                                           $scope, chart) {

        var vm = this;

        vm.clear = clear;
        vm.check = check;

        loadAll();

        function loadAll() {
            UrgentIssues.filter({chartId: chart.id, unknown: true, page: 0, size: 100}, function (result, headers) {
                var totalItems = headers('X-Total-Count');

                if (totalItems === 0) {
                    clear();
                }

                vm.urgentIssues = result;
            });
        }

        function check(urgentIssue) {
            UrgentIssues.check({id: urgentIssue.id}, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess(result) {
            loadAll();
            $scope.$emit('bluebookApp:urgentIssuesUpdate', result);
            vm.isSaving = false;
        }

        function onSaveError(error) {
            vm.isSaving = false;
        }

        function clear () {
            $uibModalInstance.dismiss(null);
        }
    }
})();
